import update from 'immutability-helper/index';
import _findIndex from 'lodash/findIndex';
import shortid from 'shortid';
import _extend from 'lodash/extend';
import _map from 'lodash/map';
import {
    ADD_IMAGES_IN_THE_SECTION_EDIT_POPUP,
    ADD_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    ADD_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    ADD_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    ADD_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    ADD_SECTION_SECTION_SETTING_IN_THE_SECTION_EDIT_POPUP,
    ADD_SECTION_IMAGE_SETTING_IN_THE_SECTION_EDIT_POPUP,
    ADD_SECTION_VIDEO_SETTING_IN_THE_SECTION_EDIT_POPUP,
    REMOVE_IMAGE_FROM_THE_SECTION_EDIT_POPUP,
    REMOVE_SINGLE_IMAGE_FROM_THE_SECTION_EDIT_POPUP,
    REMOVE_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    REMOVE_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    REMOVE_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    UPDATE_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_IMAGE_META_IN_VALUE_PROPOSITION_POPUP,
    UPDATE_SNIPPET_IMAGE_META_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_LOGO_IMAGE_META_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_IMAGE_SORT_ORDER_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_INSTRUCTIONS_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_TITLE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_THUMB_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP,
    UPDATE_THUMB_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_THUMB_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP,
    UPDATE_BODY_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_SINGLE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_MAP_SECTION_LOCATION_DESCRIPTION_IN_THE_SECTION_EDIT_POPUP,
    OPEN_EDIT_SECTION_POPUP,
    UPDATE_NOT_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP,
    ADD_DOCUMENTS_IN_THE_SECTION_EDIT_POPUP,
    REMOVE_DOCUMENT_FROM_THE_SECTION_EDIT_POPUP,
    ADD_REVIEWS_TO_SITE,
    REMOVE_REVIEWS_FOR_SITE,
    SORT_SELECTED_REVIEWS_IN_THE_SECTION_EDIT_POPUP,
    ADD_FAQS_TO_SITE,
    REMOVE_FAQS_FOR_SITE,
    SORT_SELECTED_FAQS_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_FORM_TYPE_IN_THE_SECTION_EDIT_POPUP,
    SELECT_FIND_YOUR_PROJECT_PROJECTS,
    SELECT_FIND_YOUR_PROJECT_DESTINATIONS,
    UPDATE_MEETINGS_BODY_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_CAREERS_BODY_IN_THE_SECTION_EDIT_POPUP,
    UPDATE_GROUP_TRIPS_BANNER_SECTION_SUBHEADING_FIELD,
    PICK_SECTION_PAGE,
    PICK_LARGE_SNIPPET_PAGE,
    PICK_VALUE_PROPOSITION_PAGE,
    PICK_VALUE_PROPOSITION_BUTTON_TEXT,
    UPDATE_VALUE_PROPOSITION_BODY,
    UPDATE_VALUE_PROPOSITION_TITLE,
    UPDATE_MEET_US_EVENTS_PAGE,
    UPDATE_MEET_US_MEETINGS_PAGE,
    UPDATE_MEET_US_CAREERS_PAGE,
} from './types';

import {
    PICK_PROMOTIONAL_BOXES_PAGE,
    UPDATE_PROMOTIONAL_BOX_EXTERNAL_URL,
    UPDATE_PROMOTIONAL_BOX_BUTTON_TEXT,
    UPDATE_PROMOTIONAL_BOX_HEADING,
    UPDATE_PROMOTIONAL_BOX_SUBHEADING,
    UPDATE_PROMOTIONAL_BOX_TEXT,
    ADD_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
    UPDATE_THUMB_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
    REMOVE_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
    UPDATE_IMAGE_META_IN_PROMOTIONAL_BOX_POPUP,
    UPDATE_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP,
} from './types/promotional_boxes_types';

const INITIAL_STATE = {
    sectionId: 0,
    pageId: 0,
    sectionSettings: [],
    imageSettings: [],
    videoSettings: [],
    includedFeatures: [],
    notIncludedFeatures: [],
    selectedSectionSettings: [],
    data: {
        title: '',
        body: '',
        events_page: {},
        meetings_body: '',
        meetings_page: {},
        careers_body: '',
        careers_page: {},
        form_id: '',
        instructions: '',
        image: {},
        video: {},
        images: [],
        videos: [],
        locations: [],
        features: [],
        reviews: [],
        faqs: [],
        projects: [],
        destinations: [],
        large_snippets: [],
        value_propositions: [],
        promotional_boxes: [],
        itineraries: [],
        text_columns_single_media: [],
        text_columns_multiple_media: [],
    },
};

export default function(state = INITIAL_STATE, action) {
    let toEditSettingPosition;

    switch (action.type) {
        case UPDATE_NOT_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP:
            let includedFeatures = _map(state.includedFeatures, (element) => {
                return _extend({}, element, {is_included: true});
            });

            let notIncludedFeatures = _map(
                action.payload.notIncluded,
                (element) => {
                    return _extend({}, element, {is_included: false});
                }
            );

            let features = includedFeatures.concat(notIncludedFeatures);

            return update(state, {
                data: {features: {$set: features}},
                notIncludedFeatures: {$set: action.payload.notIncluded},
            });

        case UPDATE_INCLUDED_FEATURES_IN_THE_SECTION_EDIT_POPUP:
            includedFeatures = _map(action.payload.included, (element) => {
                return _extend({}, element, {is_included: true});
            });

            notIncludedFeatures = _map(state.notIncludedFeatures, (element) => {
                return _extend({}, element, {is_included: false});
            });

            features = includedFeatures.concat(notIncludedFeatures);

            return update(state, {
                data: {features: {$set: features}},
                includedFeatures: {$set: action.payload.included},
            });

        case ADD_SECTION_SECTION_SETTING_IN_THE_SECTION_EDIT_POPUP:
            toEditSettingPosition = _findIndex(state.sectionSettings, {
                id: action.payload.forSetting.id,
            });

            if (toEditSettingPosition < 0) {
                return update(state, {
                    sectionSettings: {
                        $push: [
                            {
                                id: action.payload.forSetting.id,
                                name: action.payload.forSetting.name,
                                machine_name:
                                    action.payload.forSetting.machine_name,
                                options: action.payload.selectedOptions,
                            },
                        ],
                    },
                });
            } else {
                return update(state, {
                    sectionSettings: {
                        [toEditSettingPosition]: {
                            options: {$set: action.payload.selectedOptions},
                        },
                    },
                });
            }

        case ADD_SECTION_IMAGE_SETTING_IN_THE_SECTION_EDIT_POPUP:
            toEditSettingPosition = _findIndex(state.imageSettings, {
                id: action.payload.forSetting.id,
            });

            if (toEditSettingPosition < 0) {
                return update(state, {
                    imageSettings: {
                        $push: [
                            {
                                id: action.payload.forSetting.id,
                                name: action.payload.forSetting.name,
                                options: action.payload.selectedOptions,
                            },
                        ],
                    },
                });
            } else {
                return update(state, {
                    imageSettings: {
                        [toEditSettingPosition]: {
                            options: {$set: action.payload.selectedOptions},
                        },
                    },
                });
            }

        case ADD_SECTION_VIDEO_SETTING_IN_THE_SECTION_EDIT_POPUP:
            toEditSettingPosition = _findIndex(state.videoSettings, {
                id: action.payload.forSetting.id,
            });

            if (toEditSettingPosition < 0) {
                return update(state, {
                    videoSettings: {
                        $push: [
                            {
                                id: action.payload.forSetting.id,
                                name: action.payload.forSetting.name,
                                options: action.payload.selectedOptions,
                            },
                        ],
                    },
                });
            } else {
                return update(state, {
                    videoSettings: {
                        [toEditSettingPosition]: {
                            options: {$set: action.payload.selectedOptions},
                        },
                    },
                });
            }

        case UPDATE_TITLE_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    title: {$set: action.payload},
                },
            });

        case UPDATE_BODY_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    body: {$set: action.payload},
                },
            });

        case UPDATE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP:
            let urlVideos = [{id: action.payload.id, url: action.payload.url}];

            return update(state, {
                data: {
                    videos: {$set: urlVideos},
                },
            });

        case UPDATE_SINGLE_VIDEO_URL_IN_THE_SECTION_EDIT_POPUP:
            let urlVideo = {id: action.payload.id, url: action.payload.url};

            return update(state, {
                data: {
                    video: {$set: urlVideo},
                },
            });

        case UPDATE_FORM_TYPE_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    $merge: {
                        form_id: action.payload.formType.id,
                    },
                },
            });

        case UPDATE_INSTRUCTIONS_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {instructions: {$set: action.payload}},
            });

        case ADD_IMAGES_IN_THE_SECTION_EDIT_POPUP:
            let imgs = [];

            if (!action.payload instanceof Array) {
                imgs = [action.payload];
            } else {
                imgs = action.payload;
            }

            let imageObjects = [];

            for (let i in imgs) {
                imageObjects[i] = {
                    id: shortid.generate(),
                    url: imgs[i].preview,
                    preview: imgs[i].preview,
                    alt: '',
                    title: '',
                    description: '',
                    link: '',
                    filename: imgs[i].name,
                    name: imgs[i].name,
                    new: true,
                    deleted: false,
                    imageObject: imgs[i],
                    croppedImage: null,
                    croppedImageObject: null,
                    croppedImageThumb: null,
                    croppedImageThumbObject: null,
                    croppedImageRatioId: null,
                };
            }

            return update(state, {
                data: {images: {$push: imageObjects}},
            });

        case ADD_IMAGE_IN_THE_SECTION_EDIT_POPUP:
            let img = action.payload;

            let imageObject = {
                id: shortid.generate(),
                url: img.preview,
                preview: img.preview,
                alt: '',
                title: '',
                description: '',
                link: '',
                filename: img.name,
                name: img.name,
                new: true,
                deleted: false,
                imageObject: img,
                croppedImage: null,
                croppedImageObject: null,
                croppedImageThumb: null,
                croppedImageThumbObject: null,
                croppedImageRatioId: null,
            };

            return update(state, {
                data: {image: {$set: imageObject}},
            });

        case ADD_IMAGE_IN_VALUE_PROPOSITION_POPUP:
            let valuePropositionImg = action.payload.image;

            let valuePropositionIageObject = {
                id: shortid.generate(),
                url: valuePropositionImg.preview,
                preview: valuePropositionImg.preview,
                alt: '',
                title: '',
                description: '',
                link: '',
                filename: valuePropositionImg.name,
                name: valuePropositionImg.name,
                new: true,
                deleted: false,
                imageObject: valuePropositionImg,
                croppedImage: null,
                croppedImageObject: null,
                croppedImageThumb: null,
                croppedImageThumbObject: null,
            };

            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            image: {
                                $set: valuePropositionIageObject,
                            },
                        },
                    },
                },
            });

        case ADD_IMAGE_IN_PROMOTIONAL_BOX_POPUP:
            let promotionalBoxImg = action.payload.image;

            let promotionalBoxImageObject = {
                id: shortid.generate(),
                url: promotionalBoxImg.preview,
                preview: promotionalBoxImg.preview,
                alt: '',
                title: '',
                description: '',
                link: '',
                filename: promotionalBoxImg.name,
                name: promotionalBoxImg.name,
                new: true,
                deleted: false,
                imageObject: promotionalBoxImg,
                croppedImage: null,
                croppedImageObject: null,
                croppedImageThumb: null,
                croppedImageThumbObject: null,
            };

            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            image: {
                                $set: promotionalBoxImageObject,
                            },
                        },
                    },
                },
            });

        case ADD_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            let largeSnippetSnippetImg = action.payload.image;

            let largeSnippetSnippetImageObject = {
                id: shortid.generate(),
                url: largeSnippetSnippetImg.preview,
                preview: largeSnippetSnippetImg.preview,
                alt: '',
                title: '',
                description: '',
                link: '',
                filename: largeSnippetSnippetImg.name,
                name: largeSnippetSnippetImg.name,
                new: true,
                deleted: false,
                imageObject: largeSnippetSnippetImg,
                croppedImage: null,
                croppedImageObject: null,
                croppedImageThumb: null,
                croppedImageThumbObject: null,
            };

            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            snippet_image: {
                                $set: largeSnippetSnippetImageObject,
                            },
                        },
                    },
                },
            });

        case ADD_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            let largeSnippetLogoImg = action.payload.image;

            let largeSnippetLogoImageObject = {
                id: shortid.generate(),
                url: largeSnippetLogoImg.preview,
                preview: largeSnippetLogoImg.preview,
                alt: '',
                title: '',
                description: '',
                link: '',
                filename: largeSnippetLogoImg.name,
                name: largeSnippetLogoImg.name,
                new: true,
                deleted: false,
                imageObject: largeSnippetLogoImg,
                croppedImage: null,
                croppedImageObject: null,
                croppedImageThumb: null,
                croppedImageThumbObject: null,
            };

            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            logo_image: {
                                $set: largeSnippetLogoImageObject,
                            },
                        },
                    },
                },
            });

        case REMOVE_IMAGE_FROM_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    images: {[action.payload.index]: {$merge: {deleted: true}}},
                },
            });

        case REMOVE_SINGLE_IMAGE_FROM_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    image: {$merge: {deleted: true}},
                },
            });

        case REMOVE_IMAGE_IN_VALUE_PROPOSITION_POPUP:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            image: {$merge: {deleted: true}},
                        },
                    },
                },
            });

        case REMOVE_IMAGE_IN_PROMOTIONAL_BOX_POPUP:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            image: {$merge: {deleted: true}},
                        },
                    },
                },
            });

        case REMOVE_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            snippet_image: {$merge: {deleted: true}},
                        },
                    },
                },
            });

        case REMOVE_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            logo_image: {$merge: {deleted: true}},
                        },
                    },
                },
            });

        case UPDATE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    images: {
                        [action.payload.index]: {
                            $merge: {
                                croppedImage: action.payload.imageUrlBlob,
                                croppedImageObject:
                                    action.payload.imageBlobObject,
                            },
                        },
                    },
                },
            });

        case UPDATE_SINGLE_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    image: {
                        $merge: {
                            croppedImage: action.payload.imageUrlBlob,
                            croppedImageObject: action.payload.imageBlobObject,
                        },
                    },
                },
            });

        case UPDATE_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            image: {
                                $merge: {
                                    croppedImage: action.payload.imageUrlBlob,
                                    croppedImageObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            image: {
                                $merge: {
                                    croppedImage: action.payload.imageUrlBlob,
                                    croppedImageObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            snippet_image: {
                                $merge: {
                                    croppedImage: action.payload.imageUrlBlob,
                                    croppedImageObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            logo_image: {
                                $merge: {
                                    croppedImage: action.payload.imageUrlBlob,
                                    croppedImageObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    images: {
                        [action.payload.index]: {
                            $merge: {
                                croppedImageThumb: action.payload.imageUrlBlob,
                                croppedImageThumbObject:
                                    action.payload.imageBlobObject,
                            },
                        },
                    },
                },
            });

        case UPDATE_SINGLE_THUMB_CROPPED_IMAGE_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    image: {
                        $merge: {
                            croppedImageThumb: action.payload.imageUrlBlob,
                            croppedImageThumbObject:
                                action.payload.imageBlobObject,
                        },
                    },
                },
            });

        case UPDATE_THUMB_CROPPED_IMAGE_IN_VALUE_PROPOSITION_POPUP:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            image: {
                                $merge: {
                                    croppedImageThumb:
                                        action.payload.imageUrlBlob,
                                    croppedImageThumbObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_THUMB_CROPPED_IMAGE_IN_PROMOTIONAL_BOX_POPUP:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            image: {
                                $merge: {
                                    croppedImageThumb:
                                        action.payload.imageUrlBlob,
                                    croppedImageThumbObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_THUMB_CROPPED_SNIPPET_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            snippet_image: {
                                $merge: {
                                    croppedImageThumb:
                                        action.payload.imageUrlBlob,
                                    croppedImageThumbObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_THUMB_CROPPED_LOGO_IMAGE_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            logo_image: {
                                $merge: {
                                    croppedImageThumb:
                                        action.payload.imageUrlBlob,
                                    croppedImageThumbObject:
                                        action.payload.imageBlobObject,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    images: {
                        [action.payload.index]: {
                            $merge: {
                                alt: action.payload.imageMeta.alt,
                                title: action.payload.imageMeta.title,
                                description:
                                    action.payload.imageMeta.description,
                                link: action.payload.imageMeta.link,
                                filename: action.payload.imageMeta.name,
                                name: action.payload.imageMeta.name,
                            },
                        },
                    },
                },
            });

        case UPDATE_SINGLE_IMAGE_META_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    image: {
                        $merge: {
                            alt: action.payload.imageMeta.alt,
                            title: action.payload.imageMeta.title,
                            description: action.payload.imageMeta.description,
                            link: action.payload.imageMeta.link,
                            filename: action.payload.imageMeta.name,
                            name: action.payload.imageMeta.name,
                        },
                    },
                },
            });

        case UPDATE_SINGLE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    image: {
                        $merge: {
                            croppedImageRatioId: action.payload.cropRatioId,
                        },
                    },
                },
            });

        case UPDATE_IMAGE_CROP_RATIO_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    images: {
                        [action.payload.index]: {
                            $merge: {
                                croppedImageRatioId: action.payload.cropRatioId,
                            },
                        },
                    },
                },
            });

        case UPDATE_IMAGE_META_IN_VALUE_PROPOSITION_POPUP:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            image: {
                                $merge: {
                                    alt: action.payload.imageMeta.alt,
                                    title: action.payload.imageMeta.title,
                                    description:
                                        action.payload.imageMeta.description,
                                    link: action.payload.imageMeta.link,
                                    filename: action.payload.imageMeta.name,
                                    name: action.payload.imageMeta.name,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_IMAGE_META_IN_PROMOTIONAL_BOX_POPUP:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            image: {
                                $merge: {
                                    alt: action.payload.imageMeta.alt,
                                    title: action.payload.imageMeta.title,
                                    description:
                                        action.payload.imageMeta.description,
                                    link: action.payload.imageMeta.link,
                                    filename: action.payload.imageMeta.name,
                                    name: action.payload.imageMeta.name,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_SNIPPET_IMAGE_META_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            snippet_image: {
                                $merge: {
                                    alt: action.payload.imageMeta.alt,
                                    title: action.payload.imageMeta.title,
                                    description:
                                        action.payload.imageMeta.description,
                                    link: action.payload.imageMeta.link,
                                    filename: action.payload.imageMeta.name,
                                    name: action.payload.imageMeta.name,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_LOGO_IMAGE_META_IN_LARGE_SNIPPETS_POPUP:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            logo_image: {
                                $merge: {
                                    alt: action.payload.imageMeta.alt,
                                    title: action.payload.imageMeta.title,
                                    description:
                                        action.payload.imageMeta.description,
                                    link: action.payload.imageMeta.link,
                                    filename: action.payload.imageMeta.name,
                                    name: action.payload.imageMeta.name,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_IMAGE_SORT_ORDER_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {images: {$set: action.payload.images}},
            });

        case OPEN_EDIT_SECTION_POPUP:
            features =
                action.payload.sectionToEdit.data !== undefined &&
                action.payload.sectionToEdit.data.features !== undefined
                    ? action.payload.sectionToEdit.data.features
                    : [];

            includedFeatures = features.filter(
                (feature) => feature.is_included
            );
            notIncludedFeatures = features.filter(
                (feature) => !feature.is_included
            );

            return update(state, {
                sectionId: {$set: action.payload.sectionId},
                pageId: {$set: action.payload.pageId},
                sectionSettings: {
                    $set: action.payload.sectionToEdit.sectionSettings || [],
                },
                imageSettings: {
                    $set: action.payload.sectionToEdit.imageSettings,
                },
                videoSettings: {
                    $set: action.payload.sectionToEdit.videoSettings,
                },
                data: {$set: action.payload.sectionToEdit.data},
                includedFeatures: {$set: includedFeatures},
                notIncludedFeatures: {$set: notIncludedFeatures},
            });

        case UPDATE_MAP_SECTION_LOCATION_DESCRIPTION_IN_THE_SECTION_EDIT_POPUP:
            let newLocations = state.data.locations;

            let toEditLocationPosition = _findIndex(newLocations, {
                location_id: action.payload.locationId,
            });

            return update(state, {
                data: {
                    locations: {
                        [toEditLocationPosition]: {
                            $merge: {
                                description: action.payload.newDescription,
                            },
                        },
                    },
                },
            });

        case ADD_DOCUMENTS_IN_THE_SECTION_EDIT_POPUP:
            let documents = [];

            if (!action.payload instanceof Array) {
                documents = [action.payload];
            } else {
                documents = action.payload;
            }

            let documentObjects = [];

            for (let i in documents) {
                documentObjects[i] = {
                    doc_id: shortid.generate(),
                    link: documents[i].preview,
                    preview: documents[i].preview,
                    filename: documents[i].name,
                    name: documents[i].name,
                    new: true,
                    deleted: false,
                    documentObject: documents[i],
                };
            }

            return update(state, {
                data: {
                    itineraries: {$push: documentObjects},
                },
            });

        case REMOVE_DOCUMENT_FROM_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    itineraries: {
                        [action.payload.index]: {$merge: {deleted: true}},
                    },
                },
            });

        case ADD_REVIEWS_TO_SITE:
            let reviewsArray = [action.payload.review];

            return update(state, {
                data: {
                    reviews: {
                        $push: reviewsArray,
                    },
                },
            });

        case REMOVE_REVIEWS_FOR_SITE:
            let allReviews = state.data.reviews.filter(
                (item) => item.review_page_id !== action.payload.reviewId
            );

            return update(state, {
                data: {
                    reviews: {$set: allReviews},
                },
            });

        case SORT_SELECTED_REVIEWS_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                reviews: {$set: action.payload.selectedReviews},
            });

        case ADD_FAQS_TO_SITE:
            let faqsArray = [action.payload.faq];

            return update(state, {
                data: {
                    faqs: {
                        $push: faqsArray,
                    },
                },
            });

        case REMOVE_FAQS_FOR_SITE:
            let allFaqs = state.data.faqs.filter(
                (item) => item.id !== action.payload.faqId
            );

            return update(state, {
                data: {
                    faqs: {$set: allFaqs},
                },
            });

        case SORT_SELECTED_FAQS_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                faqs: {$set: action.payload.selectedFaqs},
            });

        case SELECT_FIND_YOUR_PROJECT_PROJECTS:
            return update(state, {
                data: {projects: {$set: action.projects}},
                touched: {$set: action.touched},
            });

        case SELECT_FIND_YOUR_PROJECT_DESTINATIONS:
            return update(state, {
                data: {destinations: {$set: action.destinations}},
                touched: {$set: action.touched},
            });

        case UPDATE_MEETINGS_BODY_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    meetings_body: {$set: action.payload},
                },
            });

        case UPDATE_CAREERS_BODY_IN_THE_SECTION_EDIT_POPUP:
            return update(state, {
                data: {
                    careers_body: {$set: action.payload},
                },
            });

        case UPDATE_GROUP_TRIPS_BANNER_SECTION_SUBHEADING_FIELD:
            return update(state, {
                data: {
                    subheading: {$set: action.payload},
                },
            });

        case PICK_SECTION_PAGE:
            return update(state, {
                data: {
                    page: {
                        $set: {
                            id: action.payload.pageId,
                            title: action.payload.pageTitle,
                        },
                    },
                },
            });

        case PICK_LARGE_SNIPPET_PAGE:
            return update(state, {
                data: {
                    large_snippets: {
                        [action.payload.largeSnippetIndex]: {
                            page: {
                                $set: {
                                    id: action.payload.pageId,
                                    title: action.payload.pageTitle,
                                },
                            },
                        },
                    },
                },
            });

        case PICK_VALUE_PROPOSITION_PAGE:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            page: {
                                $set: {
                                    id: action.payload.pageId,
                                    title: action.payload.pageTitle,
                                },
                            },
                        },
                    },
                },
            });

        case PICK_VALUE_PROPOSITION_BUTTON_TEXT:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            button_text: {
                                $set: action.payload.text,
                            },
                        },
                    },
                },
            });

        case UPDATE_VALUE_PROPOSITION_TITLE:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            title: {
                                $set: action.payload.title,
                            },
                        },
                    },
                },
            });

        case UPDATE_VALUE_PROPOSITION_BODY:
            return update(state, {
                data: {
                    value_propositions: {
                        [action.payload.valuePropositionIndex]: {
                            body: {
                                $set: action.payload.body,
                            },
                        },
                    },
                },
            });

        case PICK_PROMOTIONAL_BOXES_PAGE:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            page: {
                                $set: {
                                    id: action.payload.pageId,
                                    title: action.payload.pageTitle,
                                },
                            },
                        },
                    },
                },
            });

        case UPDATE_PROMOTIONAL_BOX_EXTERNAL_URL:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            external_url: {
                                $set: action.payload.external_url,
                            },
                        },
                    },
                },
            });

        case UPDATE_PROMOTIONAL_BOX_BUTTON_TEXT:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            button_text: {
                                $set: action.payload.button_text,
                            },
                        },
                    },
                },
            });

        case UPDATE_PROMOTIONAL_BOX_HEADING:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            heading: {
                                $set: action.payload.heading,
                            },
                        },
                    },
                },
            });

        case UPDATE_PROMOTIONAL_BOX_SUBHEADING:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            subheading: {
                                $set: action.payload.subheading,
                            },
                        },
                    },
                },
            });

        case UPDATE_PROMOTIONAL_BOX_TEXT:
            return update(state, {
                data: {
                    promotional_boxes: {
                        [action.payload.promotionalBoxIndex]: {
                            text: {
                                $set: action.payload.text,
                            },
                        },
                    },
                },
            });

        case UPDATE_MEET_US_EVENTS_PAGE:
            return update(state, {
                data: {
                    events_page: {
                        $set: {
                            id: action.payload.pageId,
                            title: action.payload.pageTitle,
                        },
                    },
                },
            });

        case UPDATE_MEET_US_MEETINGS_PAGE:
            return update(state, {
                data: {
                    meetings_page: {
                        $set: {
                            id: action.payload.pageId,
                            title: action.payload.pageTitle,
                        },
                    },
                },
            });

        case UPDATE_MEET_US_CAREERS_PAGE:
            return update(state, {
                data: {
                    careers_page: {
                        $set: {
                            id: action.payload.pageId,
                            title: action.payload.pageTitle,
                        },
                    },
                },
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/containers/builder/sections/reducer.js